export const setSelected = ({ section, select, value }) => state => {
  let index = state[section].selected.findIndex(item => item.id === value);

  if (select === true) {
    if (index === -1) {
      const item = state[section].items.find(item => item.id === value);

      return {
        ...state,
        [section]: {
          ...state[section],
          selected: state[section].selected.concat(item),
        },
      };
    }

    return;
  }

  // select === false
  if (index > -1) {
    return {
      ...state,
      [section]: {
        ...state[section],
        selected: state[section].selected.filter(item => item.id !== value),
      },
    };
  }
};
